module.exports = __webpack_public_path__ + "img/2@2x.5d48cbea.png";